import { FormattedMessage } from 'react-intl';

import { Body } from '@sorare/core/src/atoms/layout/Body';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { NoIndex } from '@sorare/core/src/contexts/seo';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { createCardSorts } from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/football';

import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { countryPageFilters } from '@sorare/marketplace/src/searchCards/football/cardFilters';

import { FootballCardSearch } from 'components/searchCards/FootballCardSearch';
import { useLayoutData } from 'pages/countries/$countryCode/layout';

const cardSortsWithBestValue = createCardSorts({
  withBestValue: true,
  withHighestAverageScore: true,
  withPopularPlayer: true,
});

export const Search = () => {
  const {
    country: { name: countryName },
    slug,
  } = useLayoutData();
  const filters = useDefaultFilters({
    nationalTeamSlug: slug,
    excludePrimaryOffers: true,
  });

  useTitleAndDescription(
    metadatas.clubCards.title,
    metadatas.clubCards.description,
    {
      club: countryName,
    }
  );

  return (
    <Body>
      <NoIndex />
      <h1 className="sr-only">
        <FormattedMessage
          id="Football.Country.Cards"
          defaultMessage="{country} Cards"
          values={{ country: countryName }}
        />
      </h1>
      <FullWidthContainer>
        <FootballCardSearch
          sorts={cardSortsWithBestValue}
          defaultSort="Popular Player"
          analyticsTags={['Country', 'Football']}
          defaultFilters={filters}
          cardFilters={countryPageFilters}
          topic={{ type: 'country', label: countryName }}
        />
      </FullWidthContainer>
    </Body>
  );
};

export default Search;
